import { unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { html, unsafeStatic } from "lit/static-html.js";
import { EkoElement } from "@/utilities/element";
import { getSafeTag, type Tag } from "@/utilities/html";
import style from "./subheading.css?inline";

@customElement("eko-subheading")
class Subheading extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property() as?: Tag; // default is `h2`
  @property({ reflect: true }) size?: "sm" | "md" | "lg" | "xl"; // default is `md`
  @property({ reflect: true }) theme?:
    | "default"
    | "danger"
    | "info"
    | "warning"
    | "weak"
    | "weaker"
    | "weakest" = "default"; // default is `default`
  @property({ type: Boolean, reflect: true }) truncate = false;

  render() {
    return html`
      <${unsafeStatic(this.tag)} class="eko-subheading">
        <slot></slot>
      </${unsafeStatic(this.tag)}>
    `;
  }

  private get tag() {
    return getSafeTag(this.as, "h2");
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-subheading": Subheading;
  }
}

export default Subheading;
